export const GROUP = 'GROUP';
export const ITEM = 'ITEM';
export const SCHEDULER_TEMPLATE = 'SCHEDULER_TEMPLATE';
